import React, { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../../assets/css/Productpage.css";
import Footer from "../HomeLandingComp/FooterComp/Footer";
import Unavbar from "../Uwebsite/UnavbarComp/Unavbar";
import apiService from "../../ApiServices/ApiServices";
import BlessnavBar from "../BlessComp/BlessnavBarComp/BlessnavBar";
import BloomNavBar from "../BloomComp/BloomNavBarComp/BloomNavBar";
import CartSlider from "../CartSlider/CartSliderBar";
import { useCart } from "../CartContext/CartContextComp";

const AddtoCart = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [productDetails, setProductDetails] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedSizeId, setSelectedSizeId] = useState(null);
  const [showSizeChart, setShowSizeChart] = useState(false);
  const { cartItems, addToCart, removeFromCart, increaseQuantity, decreaseQuantity } = useCart();
  const [cartOpen, setCartOpen] = useState(false);

  let NavbarComponent;
  if (location.pathname.startsWith("/umadras")) {
    NavbarComponent = <Unavbar />;
  } else if (location.pathname.startsWith("/bloom")) {
    NavbarComponent = <BloomNavBar />;
  } else if (location.pathname.startsWith("/bless")) {
    NavbarComponent = <BlessnavBar />;
  }

  useEffect(() => {
    const fetchProductDetails = async () => {
      try {
        const response = await apiService.get(
          `${process.env.REACT_APP_API_URL}/${id}`
        );
        const details = response.data.details || {};
        const images = response.data.images || [];
        const inventory = response.data.inventory || [];
        const brand = response.data.brand || "N/A";
        const fabrics = response.data.fabrics || [];
        const type_of_works = response.data.type_of_works || [];

         // ✅ Define size order
      const sizeOrder = ["XS", "S", "M", "L", "XL", "XXL", "3XL", "4XL", "5XL"];

      // ✅ Sort inventory sizes based on predefined order
      const sortedInventory = inventory.sort((a, b) => {
        const indexA = sizeOrder.indexOf(a.size_name);
        const indexB = sizeOrder.indexOf(b.size_name);
        return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
      });

        setProductDetails({
          ...details,
          images,
          inventory:sortedInventory,
          brand,
          fabrics,
          type_of_works,
        });
        setSelectedImage(images.length > 0 ? images[0].image_url : "");
      } catch (error) {
        console.error("Error fetching product details:", error);
        setProductDetails({});
      }
    };
    fetchProductDetails();
  }, [id]);

  const handleSizeSelection = (size,sizeId) => {
    setSelectedSize(size);
    setSelectedSizeId(sizeId);
    // console.log("Selected Size:", size);
  // console.log("Selected Size ID:", sizeId);
  };

  const handleAddToCart = () => {
    if (!selectedSize || !selectedSizeId) {
      toast.error("Please select a size before adding to cart.",{ className: "toast-error" });
      return;
    }
  
    // Find selected size in inventory to get stock value
    const selectedInventory = productDetails.inventory.find(
      (item) => item.size_name === selectedSize
    );
  
    if (!selectedInventory) {
      toast.error("Size not available.",{ className: "toast-error" });
      return;
    }
  
    // Check if item already exists in the cart
    const existingItem = cartItems.find(
      (item) => item.id === productDetails.id && item.size === selectedSize
    );
  
    if (existingItem) {
      // Prevent quantity from exceeding stock limit
      if (existingItem.quantity >= selectedInventory.stock) {
        // toast.warning(`Only ${selectedInventory.stock} items available in stock.`);
        toast.warn(`Only ${selectedInventory.stock} items available in stock.`, { className: "toast-warning" });
        return;
      }
  
      // Increase quantity if within stock limit
      increaseQuantity(productDetails.id, selectedSize);
    } else {
      // Add new item to cart
      const newItem = {
        id: productDetails.id,
        name: productDetails.name,
        price: productDetails.price,
        image: `https://admin.utharamenon.com/storage/${selectedImage}`,
        size: selectedSize,
        size_id: selectedInventory.size_id,
        quantity: 1,
        stock: selectedInventory.stock || 0,
      };
  
      addToCart(newItem);
    }
  
    setCartOpen(true);
  };
  

  if (!productDetails) {
    return <div>Loading...</div>;
  }

  return (
    <>
      {NavbarComponent}
      <div className="collections-container">
        <button className="collection-button" onClick={() => navigate(-1)}>
          &lt; Back
        </button>
        <h2 className="collection-title">Collection</h2>

        <div className="collection-content">
          <div className="collection-gallery">
            {productDetails?.images?.length > 0 ? (
              productDetails.images.map((img, index) => (
                <img
                  key={index}
                  src={`https://admin.utharamenon.com/storage/${img.image_url}`}
                  alt={`Thumbnail ${index + 1}`}
                  className="collection-thumbnail"
                  onClick={() => setSelectedImage(img.image_url)}
                />
              ))
            ) : (
              <p>No images available</p>
            )}
          </div>

          <div className="collection-main-image">
            <img
              src={`https://admin.utharamenon.com/storage/${selectedImage}`}
              alt="Product"
            />
          </div>

          <div className="collection-info">
            <h3>{productDetails?.name || "Product Name"}</h3>
            <p className="collection-price">Rs. {productDetails?.price || "N/A"}</p>

            <div className="collection-size">
              <p>Select Size</p>
              <div className="size-options">
                {productDetails?.inventory?.length > 0 ? (
                  productDetails.inventory.map((inventory, index) => (
                    <button
                      key={index}
                      className={`size-btn ${selectedSize === inventory.size_name ? "selected" : ""}`}
                      onClick={() => handleSizeSelection(inventory.size_name, inventory.size_id)}
                      disabled={inventory.stock === 0} // Disable button if stock is 0
                      style={{ opacity: inventory.stock === 0 ? 0.5 : 1, cursor: inventory.stock === 0 ? "not-allowed" : "pointer" }} 
                    >
                      {inventory.size_name}
                    </button>
                  ))
                ) : (
                  <p>No sizes available</p>
                )}
              </div>

              <div className="collection-size">
                <p className="size-chart" onClick={() => setShowSizeChart(true)}>
                  Size Chart
                </p>
              </div>
            </div>

            <button className="add-to-cart" onClick={handleAddToCart}style={{ width: "60%"}}>
              Add to Cart
            </button>

            <div className="collection-details">
              <p>
                <strong>Brand</strong>
                <br /> {productDetails?.brand || "N/A"}
              </p>
              <p>
                <strong>Category</strong>
                <br /> {productDetails?.category || "N/A"}
              </p>
              <p>
                <strong>Type of Work</strong>
                <br />{" "}
                {(productDetails?.type_of_works || []).join(", ") || "N/A"}
              </p>
              <p>
                <strong>Fabric</strong>
                <br /> {(productDetails?.fabrics || []).join(", ") || "N/A"}
              </p>
              <p>
                <strong>Pack Contains</strong>
                <br /> {productDetails?.pack_contains || "N/A"}
              </p>
              <p>
                <strong>Care Instructions</strong>
                <br /> {productDetails?.care_instructions || "N/A"}
              </p>
            </div>
          </div>
        </div>

        {showSizeChart && productDetails?.size_chart && (
          <div className="popup-overlay">
            <div className="popup-content">
              <span
                className="close-popup"
                onClick={() => setShowSizeChart(false)}
              >
                ×
              </span>
              <img
                src={`https://admin.utharamenon.com/storage/${productDetails.size_chart}`}
                alt="Size Chart"
                className="size-chart-image"
              />
            </div>
          </div>
        )}
      </div>

      {cartOpen && (
        <CartSlider
          cartItems={cartItems}
          onClose={() => setCartOpen(false)}
          onRemove={removeFromCart}
          onIncrease={increaseQuantity}
          onDecrease={decreaseQuantity}
        />
      )}
<ToastContainer position="top-right" autoClose={3000}  hideProgressBar={false} closeButton={false} />

      <Footer />
    </>
  );
};

export default AddtoCart;